/* eslint-disable react/prop-types */
import styles from "./keyInfo.module.scss";

interface KeyInfoProps {
  config: Array<{
    title: string;
    key: string;
    dataIndex: string;
    render?: (_value: any) => React.ReactNode;
  }>;
  data: Record<string, any>;
  titleClass?: string;
  rootContainer?: string;
  itemClass?: string;
}

/**
 * A component to display key-value information based on a configuration.
 *
 * @param {KeyInfoProps} props - The props for the KeyInfo component.
 * @param {Array} props.config - Configuration for rendering key-value pairs.
 * @param {Object} props.data - Data object containing the values to display.
 */
export default function Keyinfo({ config, data, titleClass, rootContainer, itemClass }: KeyInfoProps) {
  /**
   * Get the rendered value for a given data index.
   *
   * @param {string} dataIndex - The key to access the value in the data object.
   * @param {Function} render - Optional render function to customize the display.
   * @returns {React.ReactNode} The rendered value or "---" if the value is undefined.
   */
  const getRenderedData = (dataIndex: string, render: (_value: any) => React.ReactNode = (val) => val) => {
    const value = data?.[dataIndex];

    return value !== undefined ? render(value) : "---";
  };

  return (
    <div className={`${styles.keyInfoContainer} ${rootContainer}`}>
      {config.map(({ title, key, dataIndex, render }) => (
        <div key={key} className={styles.fRow}>
          <div className={`${styles.title} ${titleClass}`}>{title}</div>
          <div className={`${styles.item} ${itemClass}`}>:</div>
          <div className={`${styles.item} ${itemClass}`}>{getRenderedData(dataIndex, render)}</div>
        </div>
      ))}
    </div>
  );
}
